import { isNavigationItemActive } from "../../navigation/navigationConfig";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

export default function WorkspaceCompactIconMenu({
  groups = [],
  location,
  activeGroup = null,
  activeGroupKey = "",
  onGroupSelect,
  onNavigate,
}) {
  if (!Array.isArray(groups) || groups.length === 0) {
    return null;
  }

  return (
    <div className="hidden shrink-0 lg:flex">
      <aside className="sticky top-[112px] h-[calc(100vh-170px)] w-20 overflow-hidden rounded-l-2xl border border-r-0 border-slate-200 bg-slate-950 shadow-sm">
        <nav
          aria-label="Compact hoofdmenu"
          className="flex h-full flex-col items-center gap-3 overflow-y-auto px-3 py-4"
        >
          {groups.map((group) => {
            const Icon = group.icon;
            const isActive = group.key === activeGroupKey;
            return (
              <button
                key={group.key}
                type="button"
                onClick={() => onGroupSelect?.(group.key)}
                className={joinClasses(
                  "inline-flex h-12 w-12 items-center justify-center rounded-2xl transition",
                  isActive
                    ? "bg-white text-slate-950 shadow-sm"
                    : "text-slate-300 hover:bg-white/10 hover:text-white"
                )}
                title={group.label}
                aria-label={group.label}
              >
                {Icon ? <Icon className="h-5 w-5" /> : null}
              </button>
            );
          })}
        </nav>
      </aside>

      <aside className="sticky top-[112px] h-[calc(100vh-170px)] w-72 overflow-hidden rounded-r-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 px-4 py-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            {activeGroup?.label || "Navigatie"}
          </p>
          {activeGroup?.description ? (
            <p className="mt-1 text-sm leading-6 text-slate-600">
              {activeGroup.description}
            </p>
          ) : null}
        </div>

        <nav className="max-h-[calc(100%-88px)] overflow-y-auto p-3" aria-label="Compact submenu">
          <div className="space-y-1">
            {(activeGroup?.items || []).map((item) => {
              const itemActive = isNavigationItemActive(item, location);
              const ItemIcon = item.icon;
              return (
                <button
                  key={item.to}
                  type="button"
                  onClick={() => onNavigate?.(item.to)}
                  className={joinClasses(
                    "flex w-full items-start gap-3 rounded-xl px-3 py-3 text-left transition",
                    itemActive
                      ? "bg-blue-50 text-blue-900"
                      : "text-slate-700 hover:bg-slate-50"
                  )}
                >
                  {ItemIcon ? (
                    <span
                      className={joinClasses(
                        "mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl",
                        itemActive ? "bg-blue-100 text-blue-700" : "bg-slate-100 text-slate-600"
                      )}
                    >
                      <ItemIcon className="h-4 w-4" />
                    </span>
                  ) : null}

                  <span className="min-w-0 flex-1">
                    <span className="flex items-center gap-2">
                      <span className="truncate text-sm font-semibold">{item.label}</span>
                      {item.badge ? (
                        <span className="rounded-full bg-red-100 px-2 py-0.5 text-[11px] font-semibold text-red-700">
                          {item.badge}
                        </span>
                      ) : null}
                    </span>
                    {item.description ? (
                      <span className="mt-1 block text-xs leading-5 text-slate-500">
                        {item.description}
                      </span>
                    ) : null}
                  </span>
                </button>
              );
            })}
          </div>
        </nav>
      </aside>
    </div>
  );
}
